import React, { useEffect, useState } from 'react'
import isNull from '../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../utils/FormValidator';
import { Modal, ModalBody } from "react-bootstrap";
import DatePicker from '../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../Setup/Shared/ModalHeader';
import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';
import { useSelector } from 'react-redux';
import handleNumericCheck from '../../../../../../../../../../../utils/HandleNumericKeys';
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../General/DeleteConfirmation';

const RiskScoreTypeData = [
    { value: '-1', display: '' },
    { display: 'Hierarchical Condition Category (HCC)', value: 'HCC' },
    { display: 'Adjusted Clinical Groups (ACG)', value: 'ACG' },
    { display: 'Elder Risk Assessment (ERA)', value: 'ERA' },
    { display: 'Chronic Comorbidity Counts (CCC)', value: 'CCC' },
    { display: 'Minnesota Tiering (MN)', value: 'MN' },
    { display: 'Other', value: 'Other' }, // Allow custom input if this is selected
];
const AddPatientRiskScore = ({ setIsRecordSaved, ...props }) => {
    const { isOpenPatientRiskScore, onClose, onDeletePatientRiskScore } = { ...props }
    let { patientID, IsEditAllowed } = props;
    // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true)).data?.id;
    const API_URL = enumUtil.controller.General
    let PatientRiskScore_Modal = {
        RiskType: "",
        RiskScoreType: "",
        Score: "",
        EffectiveDate: "",
        Notes:  ""
    }
    let valModal = {}
    let ValidationModal = {
        RiskTypeVal: "",
        RiskScoreTypeVal: "",
        RiskScoreVal: "",
        AssignedDateVal: "",
    }
    const [patientRiskScoreID, setPatientRiskScoreID] = useState();
    const [riskTypeSelected, setRiskTypeSelected] = useState(false);
    const [isEdit, setIsEdit] = useState(true)
    const [riskScoreTypeData, setRiskScoreTypeData] = useState([])
    // const [selectedRiskType,setSelectedRiskType] = useState([])

    const [patientRiskScoreValidationModal, setPatientRiskScoreValidationModal] = useState(ValidationModal)
    const [patientRiskScoreSaveUpdateModal, setPatientRiskScoreSaveUpdateModal] = useState({})
    const [mainPatientRiskScoreModal, setMainPatientRiskScoreModal] = useState(PatientRiskScore_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onPatientRiskScoreSaved, setOnPatientRiskScoreSaved] = useState(false)
    const [del, setDel] = useState(false)
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [riskTypeBody, setRiskTypeBody] = useState({ "TableName": enumUtil.enumAPITableName.PatientImplantableDevice, "SearchParam": '' })
    const [is, setIs] = useState(false);
    console.log("AddNewProblem", props)
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);

    useEffect(() => {
        ServerRequestProtected(API_URL + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientRiskScore,
        }).then((response) => {
            setRiskScoreTypeData(response);
        }).catch((error) => {
        })
    }, [])

    useEffect(() => {
        // setPracticeID(PracticeID)
        if (props.patientRiskScoreID != null) {
            setDel(true)
            setPatientRiskScoreID(props.patientRiskScoreID)
        } else {
            if (!onPatientRiskScoreSaved) {
                setPatientRiskScoreID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(patientRiskScoreID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": patientRiskScoreID,
                "TableName": enumUtil.enumAPITableName.PatientRiskScore
            }).then((response) => {
                setIsLoading(false);
                setIsEdit(false);
                setRiskTypeSelected(true);
                setIs(true)
                setMainPatientRiskScoreModal(response);
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [patientRiskScoreID])

    const PatientRiskScoreValidation = async () => {
        let ValidationModal = {
            RiskTypeVal: FormValidator(
                mainPatientRiskScoreModal.RiskType,
                enumUtil.enumValidationType.Required,
                'Risk Type',
            ),
            ...(mainPatientRiskScoreModal.RiskType === "Other" ?
                {
                    RiskScoreTypeVal:
                        FormValidator(
                            mainPatientRiskScoreModal.RiskScoreType,
                            enumUtil.enumValidationType.Required,
                            'Risk Score Type'
                        )
                } : {}),
            RiskScoreVal: FormValidator(
                mainPatientRiskScoreModal.Score,
                enumUtil.enumValidationType.Required,
                'Risk Score',
            ),
            EffectiveDateVal: FormValidator(
                mainPatientRiskScoreModal.EffectiveDate,
                enumUtil.enumValidationType.Required,
                'Effective Date',
            ),

        }
        await setPatientRiskScoreValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSavePatientRiskScore = async () => {
        if(!IsEditAllowed) return;
        await PatientRiskScoreValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientRiskScore,
                ID: patientRiskScoreID,
                Data: { PatientID: patientID, ...patientRiskScoreSaveUpdateModal },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false);
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success);
                        setIsRecordSaved(true);
                        setPatientRiskScoreID(response.id)
                        setOnPatientRiskScoreSaved(true)
                        onClose()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleClear = () => {
        setMainPatientRiskScoreModal(PatientRiskScore_Modal);
        setPatientRiskScoreSaveUpdateModal({});
    }

    //   const handleSetCheckbox = (e) => {
    //     let { name, checked } = e.target
    //     let modal = { ...mainPatientRiskScoreModal };
    //     let saveModal = { ...patientRiskScoreSaveUpdateModal}
    //     modal[name] = String(checked);
    //     setMainPatientRiskScoreModal(modal)
    //     for (var property in PatientRiskScore_Modal) {
    //       if (name === property) {
    //         saveModal[name] = String(checked);
    //       }
    //     }
    //     setPatientRiskScoreSaveUpdateModal(saveModal)
    //   }
    const handleChange = (e) => {
        setIs(false);
        let { name, value } = e.target
        let modal = { ...mainPatientRiskScoreModal };
        let saveModal = { ...patientRiskScoreSaveUpdateModal }
        modal[name] = value
        setMainPatientRiskScoreModal(modal)
        for (var property in PatientRiskScore_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setPatientRiskScoreSaveUpdateModal(saveModal)
    }

    const handleChangeRiskScore = (e) => {
        setIs(false);
        const minValue = 1;
        const maxValue = 10;
        let { name, value } = e.target;

        // Allow empty values for clearing input
        if (value === "") {
            let modal = { ...mainPatientRiskScoreModal };
            let saveModal = { ...patientRiskScoreSaveUpdateModal }
            modal[name] = value
            setMainPatientRiskScoreModal(modal)
            for (var property in PatientRiskScore_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setPatientRiskScoreSaveUpdateModal(saveModal);
            return;
        }
        const numValue = Number(value);

        if (!isNaN(numValue) && numValue >= minValue && numValue <= maxValue) {
            let modal = { ...mainPatientRiskScoreModal };
            let saveModal = { ...patientRiskScoreSaveUpdateModal }
            modal[name] = value
            setMainPatientRiskScoreModal(modal)
            for (var property in PatientRiskScore_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setPatientRiskScoreSaveUpdateModal(saveModal);
        }
    };
    const handleDateChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainPatientRiskScoreModal };
        let saveModal = { ...patientRiskScoreSaveUpdateModal }
        modal[type] = FormatedDate
        setMainPatientRiskScoreModal(modal)
        for (var property in PatientRiskScore_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setPatientRiskScoreSaveUpdateModal(saveModal)
    }

    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...mainPatientRiskScoreModal };
        if (type === 'client' && !isNull(selectedData) && ![ -1, "-1"].includes(selectedData?.value)) {
            if (name === "RiskType") {
                modal[name] = selectedData.display;
                patientRiskScoreSaveUpdateModal[name] = selectedData.display + "";
                patientRiskScoreSaveUpdateModal['RiskTypeID'] = selectedData.value + "";
                // setSelectedRiskType(selectedData.display);
                setIsEdit(false);
                setRiskTypeSelected(true);
            } else if (name === "ProviderID") {
                modal[name] = selectedData.display
                patientRiskScoreSaveUpdateModal[name] = selectedData.value + "";
                // setProviderID(selectedData.value + "")
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'RiskType') {
                patientRiskScoreSaveUpdateModal[name] = selectedData.display + "";
                modal[name] = selectedData.display;
                setIsEdit(false);
            }
        } else {

            modal[name] = ''
            patientRiskScoreSaveUpdateModal[name] = ''
            if (name === 'RiskType') {
                setRiskTypeSelected(false);
            }
        }
        setMainPatientRiskScoreModal(modal)
        return selectedData
    }

    const PatientRiskScoreName = () => {
        return (
            <p className="heading">Add New Patient Risk Score</p>
        )
    }
    const handleRiskTypeChange = (e) => {
        setIs(false)
        setMainPatientRiskScoreModal(prev => ({ ...prev, RiskType: e.target.value }));
        setRiskTypeBody({ "TableName": enumUtil.enumAPITableName.PatientRiskScore, "SearchParam": e.target.value })
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }

    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientRiskScore}
                ID={patientRiskScoreID}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }
    return (
        <Modal show={isOpenPatientRiskScore} onHide={isOpenPatientRiskScore} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={PatientRiskScoreName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                {/* <div className="pt-2">
              {console.log("mainPatientRiskScoreModal",mainPatientRiskScoreModal)}
                <div className="input mb-2">
                    <div className='input-group hk-input-search'>
                        <input type="text" className='form-control'
                            placeholder='Search problem here...'
                        />
                        <span className="input-group-text seraches" id="basic-addon2">
                            <i className="bi bi-search"></i>
                        </span>
                    </div>
                </div>
                <div className="blue-bg-header mb-2">
                    <p className="heading text-white">Asthma(ICD:10 WOI90S)</p>
                </div>
                <div className="d-flex align-items-center gap-3 mb-12">
                    <p className="text font-m">Acuity:</p>
                    <div className="d-flex align-items-center gap-2">
                      <div className="ar_radio-btn d-flex align-items-center">
                          <input
                              type="radio"
                              id="Chronic"
                              name="Acuity"
                              onChange={handleChange}
                          />
                          <label htmlFor="Chronic" className="text ar-orange-text">Chronic</label>
                      </div>
                      <div className="ar_radio-btn d-flex align-items-center">
                          <input
                              type="radio"
                              id="Acute"
                              name="Acuity"
                              onChange={handleChange}
                          />
                          <label htmlFor="Acute" className="text ar-orange-text">Acute</label>
                      </div>
                      <div className="ar_radio-btn d-flex align-items-center">
                          <input
                              type="radio"
                              id="Undefined"
                              name="Acuity"
                              onChange={handleChange}
                          />
                          <label htmlFor="Undefined" className="text ar-orange-text">Undefined</label>
                      </div>
                    </div>
                </div>
                <div className="d-flex align-items-end gap-15 mb-12">
                    <div className="input mb-0">
                        <label className="pb-3px">Start Date</label>
                        <DatePicker 
                          value={mainPatientRiskScoreModal.EndDate}
                          handleCalendarChangefunc={date => handleDateChange(date,'StartDate')} />
                    </div>
                    <div className="input mb-0">
                        <label className="pb-3px">End Date</label>
                        <DatePicker 
                          value={mainPatientRiskScoreModal.EndDate}
                          handleCalendarChangefunc={date => handleDateChange(date,'EndDate')} />
                    </div>
                    <div className='d-flex align-items-center gap-6'>
                        <div className="custom_check_box">
                            <input
                                type="checkbox"
                                className="form-check-input p-0"
                                name="AssociateWithEncounter"
                                id="AssociateWithEncounter"
                                checked={mainPatientRiskScoreModal.AssociateWithEncounter === "true" ? true : false}
                                onChange={handleSetCheckbox}
                            />
                        </div>
                        <p className='text font-m text-nowrap'>Associate with encounter</p>
                    </div>
                </div>
                <div className="input">
                    <label className="pb-3px">Reason</label>
                    <textarea rows="2" className="form-control"></textarea>
                </div>
            </div> */}
                <div className="">
                    {isEdit ?
                        <div className={`input claims_info search-icon-icdSearch" form-group mb-12 ${patientRiskScoreValidationModal.RiskTypeVal ? 'error' : ''}`}>
                            {/* <i className='icon-Clip-path-group top-50 translate-middle-y'></i> */}
                            {/* <SuperSearchList
                                type='server'
                                id='RiskType'
                                name='RiskType'
                                searchValue={mainPatientRiskScoreModal.RiskType}
                                ApiLink={API_URL + "/DropDown"}
                                method='post'
                                postBody={riskTypeBody}
                                onChange={handleRiskTypeChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                icon={true}
                                disabled={true}
                                placeholder='Search existing problems or allergies here...'
                                inputError={patientRiskScoreValidationModal.RiskTypeVal}
                            /> */}
                            <SuperSearchList
                                type="client"
                                id='RiskType'
                                name='RiskType'
                                searchValue={mainPatientRiskScoreModal.RiskType}
                                data={riskScoreTypeData}
                                onChange={handleChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                placeholder="Select type..."
                                inputError={patientRiskScoreValidationModal.RiskTypeVal}
                            />
                            {/* <SuperSearchList
                        type="client"
                        id='RiskType'
                        name='RiskType'
                        searchValue={mainPatientRiskScoreModal.RiskType}
                        data={RiskScoreTypeData}
                        onChange={handleChange}
                        getSelectedData={handleSelectedData}
                        is={is}
                        sup_btn='sup_btn-Inp'
                        sup_inp='superSearchVisitInp'
                        placeholder="Select type..."
                        inputError={patientRiskScoreValidationModal.RiskTypeVal}
                    /> */}
                            {patientRiskScoreValidationModal.RiskTypeVal}
                        </div> :
                        <>
                            {console.log("ssd", mainPatientRiskScoreModal.RiskType && mainPatientRiskScoreModal.RiskType !== "Other")}

                            {
                                // ((mainPatientRiskScoreModal.RiskType && mainPatientRiskScoreModal.RiskType !== "Other") ||
                                // (mainPatientRiskScoreModal.RiskType === "Other" && mainPatientRiskScoreModal.RiskScoreType)) &&
                                <div className="mb-2 d-flex align-items-center justify-content-between gap-15 px-1">
                                    <p className="text fs-13 font-m ar-dark-color validation_message text-nowrap"> <span className='text-decoration-underline'>{mainPatientRiskScoreModal.RiskType}</span> <span className=''></span></p>
                                    <i className='icon-edit-pencil fs-12' onClick={() => setIsEdit(prev => !prev)}></i>
                                </div>
                            }
                        </>}
                    {riskTypeSelected &&
                        <>
                            {/* Jab dropdown me user other select kre ga to ye div aye ga */}
                            {mainPatientRiskScoreModal.RiskType === "Other" &&
                                <div className="mb-12">
                                    <div className={`input mb-0 ${patientRiskScoreValidationModal.RiskScoreTypeVal ? 'error' : ''}`}>
                                        <label className="pb-3px">Risk Score Type</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="RiskScoreType"
                                            id="RiskScoreType"
                                            value={mainPatientRiskScoreModal.RiskScoreType}
                                            onChange={handleChange}
                                        />
                                        {patientRiskScoreValidationModal.RiskScoreTypeVal}
                                    </div>
                                </div>}

                            <div className="d-flex align-items-end gap-15 mb-12">
                                <div className={`input mb-0 ${patientRiskScoreValidationModal.RiskScoreVal ? 'error' : ''}`}>
                                    <label className="pb-3px">Risk Score</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="Score"
                                        id="Score"
                                        value={mainPatientRiskScoreModal.Score}
                                        onChange={handleChangeRiskScore}
                                        // onKeyPress={(event) => handleNumericCheck(event)}        
                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                    />
                                    {patientRiskScoreValidationModal.RiskScoreVal}
                                </div>
                                <div className={`input mb-0 ${patientRiskScoreValidationModal.EffectiveDateVal ? 'error' : ''}`}>
                                    <DatePicker
                                        label="Effective Date"
                                        className={`mb-0`}
                                        value={mainPatientRiskScoreModal.EffectiveDate}
                                        handleCalendarChangefunc={date => handleDateChange(date, 'EffectiveDate')} />
                                    {patientRiskScoreValidationModal.EffectiveDateVal}
                                </div>
                            </div>
                            <div className='input' >
                                <label className="pb-3px">Notes</label>
                                <textarea 
                                    rows="3" 
                                    className="form-control"
                                    id='Notes'
                                    name='Notes'
                                    value={mainPatientRiskScoreModal.Notes}
                                    onChange={handleChange}
                                />
                            </div>
                        </>}
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-end gap-2">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSavePatientRiskScore}>Save</button>
            </div>
        </Modal>
    )
}

export default AddPatientRiskScore